import React, { useRef } from 'react';
import ProfileSummary from './profileSummary';
import Password from './password';
import ReceivingResponses from './receivingResponses';
import Notifications from './notifications';
import DBYDLinkStatus from './dbydLinkStatus';
import DBYDRelinkEmail from './dbydRelinkEmail';
import PageDirectory from './pageDirectory';
import { SCREEN_SIZE } from 'types';

const smallScreens = [SCREEN_SIZE.MD, SCREEN_SIZE.SM];

const Profile: React.FC<Props> = ({
  user,
  screenSize,
  onClickLinkAccount,
  onClickUnlinkAccount,
  isUnlinkingDBYD,
  updateUserProfile,
  isSetEmailLinking,
  onClickRelinkEmail
}) => {
  const DBYDLinkStatusRef = useRef<HTMLDivElement>(null);
  if (window.location.hash === '#dbydLinkingStatus') {
    setTimeout(() => {
      DBYDLinkStatusRef.current &&
        DBYDLinkStatusRef.current.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        window.location.hash = '';
      }, 1000);
    }, 100);
  }

  return (
    <div id="profile" className="profile">
      <div id="mainContent" className="settings-main-content">
        <div id="profileSummary" className="main-section-title spacing-padding">
          User details
        </div>
        <div id="profileSummarySection">
          <ProfileSummary user={user} />
        </div>

        <div className="divider"></div>

        <div id="passwordSection">
          <Password user={user} />
        </div>

        <div className="divider"></div>

        <div className="main-section-title spacing-padding">
          User preferences
        </div>
        <div id="receivingResponsesSection">
          <ReceivingResponses
            user={user}
            updateUserProfile={updateUserProfile}
          />
        </div>

        <div className="divider"></div>

        <div id="notificationsSection">
          <Notifications user={user} updateUserProfile={updateUserProfile} />
        </div>

        <div className="divider"></div>

        <div className="main-section-title spacing-padding">
          BYDA account details
        </div>
        <div id="DBYDDetailsSection" ref={DBYDLinkStatusRef}>
          <DBYDLinkStatus
            user={user}
            onClickLinkAccount={onClickLinkAccount}
            onClickUnlinkAccount={onClickUnlinkAccount}
            isUnlinkingDBYD={isUnlinkingDBYD}
          />
        </div>
        {user?.is_linked && !user?.is_email_linked && (
          <div id="DBYDRelinkSection">
            <DBYDRelinkEmail
              user={user}
              isSetEmailLinking={isSetEmailLinking}
              onClickRelinkEmail={onClickRelinkEmail}
            />
          </div>
        )}
      </div>

      {screenSize !== undefined && !smallScreens.includes(screenSize) && (
        <div id="rightContent" className="settings-right-content">
          <PageDirectory />
        </div>
      )}
    </div>
  );
};

interface Props {
  user: any;
  screenSize: any;
  onClickLinkAccount: Function;
  onClickUnlinkAccount: Function;
  unlinkDBYDResponse: any;
  isUnlinkingDBYD: boolean;
  updateUserProfile: Function;
  isSetEmailLinking: boolean;
  onClickRelinkEmail: Function;
}

export default React.memo(Profile);
